import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { Switch } from '@/components/ui/switch'
import { useAgentConfig } from '../../context/agent-config-context'
import {
  IconRobot,
  IconVolume,
  IconSend,
  IconVariable,
} from '@tabler/icons-react'

export function SkillsTab() {
  const { config, updateConfig } = useAgentConfig()

  return (
    <ScrollArea className='h-[calc(100vh-16rem)] pr-4'>
      <div className='space-y-6'>
        <div>
          <h3 className='text-lg font-medium'>Habilidades do Agente</h3>
          <p className='text-sm text-muted-foreground'>
            Configure as funcionalidades e capacidades especiais do agente.
          </p>
        </div>

        {/* Ativar/Desativar Agente */}
        <Card>
          <CardHeader>
            <div className='flex items-center gap-3'>
              <div className='p-2 bg-primary/10 rounded-lg'>
                <IconRobot className='w-5 h-5 text-primary' />
              </div>
              <div className='flex-1'>
                <CardTitle>Status do Agente</CardTitle>
                <CardDescription>
                  Ative ou desative o agente para controlar se ele responderá
                  mensagens.
                </CardDescription>
              </div>
              <Switch
                checked={config.isActive}
                onCheckedChange={(checked) =>
                  updateConfig({ isActive: checked })
                }
              />
            </div>
          </CardHeader>
        </Card>

        <Separator />

        {/* Responder Áudios */}
        <Card>
          <CardHeader>
            <div className='flex items-center gap-3'>
              <div className='p-2 bg-primary/10 rounded-lg'>
                <IconVolume className='w-5 h-5 text-primary' />
              </div>
              <div className='flex-1'>
                <CardTitle>Responder com Áudio</CardTitle>
                <CardDescription>
                  Permite que o agente transcreva áudios recebidos e responda
                  também por áudio.
                </CardDescription>
              </div>
              <Switch
                checked={config.canRespondAudio}
                onCheckedChange={(checked) =>
                  updateConfig({ canRespondAudio: checked })
                }
              />
            </div>
          </CardHeader>

          {config.canRespondAudio && (
            <CardContent className='pt-0'>
              <div className='space-y-3'>
                <Label>Voz para Resposta em Áudio</Label>
                <RadioGroup
                  value={config.audioVoice}
                  onValueChange={(value: 'male' | 'female') =>
                    updateConfig({ audioVoice: value })
                  }
                >
                  <div className='flex items-center space-x-2'>
                    <RadioGroupItem value='female' id='female' />
                    <Label htmlFor='female' className='font-normal'>
                      Voz Feminina
                    </Label>
                  </div>
                  <div className='flex items-center space-x-2'>
                    <RadioGroupItem value='male' id='male' />
                    <Label htmlFor='male' className='font-normal'>
                      Voz Masculina
                    </Label>
                  </div>
                </RadioGroup>
              </div>
            </CardContent>
          )}
        </Card>

        <Separator />

        {/* Recursos Futuros (Escopo 2) */}
        <div className='space-y-4'>
          <div>
            <h4 className='text-sm font-medium text-muted-foreground'>
              Recursos Avançados (Em breve)
            </h4>
          </div>

          <Card className='opacity-50'>
            <CardHeader>
              <div className='flex items-center gap-3'>
                <div className='p-2 bg-muted rounded-lg'>
                  <IconSend className='w-5 h-5 text-muted-foreground' />
                </div>
                <div className='flex-1'>
                  <CardTitle className='text-muted-foreground'>
                    Iniciar Campanhas
                  </CardTitle>
                  <CardDescription>
                    Envie mensagens proativas em massa via WhatsApp.
                  </CardDescription>
                </div>
                <Switch disabled checked={false} />
              </div>
            </CardHeader>
          </Card>

          <Card className='opacity-50'>
            <CardHeader>
              <div className='flex items-center gap-3'>
                <div className='p-2 bg-muted rounded-lg'>
                  <IconVariable className='w-5 h-5 text-muted-foreground' />
                </div>
                <div className='flex-1'>
                  <CardTitle className='text-muted-foreground'>
                    Gerenciamento de Variáveis
                  </CardTitle>
                  <CardDescription>
                    Gerencie variáveis e estado da conversa de forma avançada.
                  </CardDescription>
                </div>
                <Switch disabled checked={false} />
              </div>
            </CardHeader>
          </Card>
        </div>
      </div>
    </ScrollArea>
  )
}
